import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'

export const enum PageIdWoofz22V4t {
  SEX_22V4T = PageId.SEX_22V4T,
  DOG_AGE_22V4T = PageId.DOG_AGE_22V4T,
  DOG_BREED_22V4T = PageId.DOG_BREED_22V4T,
  URGE_22V4T = PageId.URGE_22V4T,
  COMMANDS_61_22V4T = PageId.COMMANDS_61_22V4T,
  COMMANDS_62_22V4T = PageId.COMMANDS_62_22V4T,
  COMMANDS_63_22V4T = PageId.COMMANDS_63_22V4T,
  URGE_2_22V4T = PageId.URGE_2_22V4T,
  POTTY_22V4T = PageId.POTTY_22V4T,
  BEHAVIOR_22V4T = PageId.BEHAVIOR_22V4T,
  TRAINING_22V4T = PageId.TRAINING_22V4T,
  PREPARE_FLOW_22V4T = PageId.PREPARE_FLOW_22V4T,
  DOG_STATISTICS_22V4T = PageId.DOG_STATISTICS_22V4T,
  EMAIL_22V4T = PageId.EMAIL_22V4T,
  NEWSLETTER_URGE_22V4T = PageId.NEWSLETTER_URGE_22V4T,
  LAST_CHANCE_OFFER_22V4T = PageId.LAST_CHANCE_OFFER_22V4T,
  SUBSCRIPTIONS_22V4T = PageId.SUBSCRIPTIONS_22V4T,
  CANCEL_OFFER_22V4T = PageId.CANCEL_OFFER_22V4T,
  CHAT_UPSELL_22V4T = PageId.CHAT_UPSELL_22V4T,
  UPSELL_22V4T = PageId.UPSELL_22V4T,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_22V4T = PageId.DOWNLOAD_22V4T,
}

type TIdToPageMapWoofz22V4t = Record<PageIdWoofz22V4t, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ22V4T: TIdToPageMapWoofz22V4t = {
  sex_22v4t: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4t/pages/questions/SexQuesiton').then(
        (m) => ({
          default: m.SexQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4t/pages/questions/SexQuesiton'),
  },
  dog_age_22v4t: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4t/pages/questions/DogAgeQuestion').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4t/pages/questions/DogAgeQuestion'),
  },
  dog_breed_22v4t: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4t/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4t/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  urge_5_22v4t: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4t/pages/questions/UrgePage').then(
        (m) => ({
          default: m.UrgePage,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz22_v4t/pages/questions/UrgePage'),
  },
  commands_61_22v4t: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4t/pages/questions/CommandsVariant61'
      ).then((m) => ({
        default: m.CommandsVariant61,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4t/pages/questions/CommandsVariant61'),
  },
  commands_62_22v4t: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4t/pages/questions/CommandsVariant62'
      ).then((m) => ({
        default: m.CommandsVariant62,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4t/pages/questions/CommandsVariant62'),
  },
  commands_63_22v4t: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4t/pages/questions/CommandsVariant63'
      ).then((m) => ({
        default: m.CommandsVariant63,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4t/pages/questions/CommandsVariant63'),
  },
  urge_2_22v4t: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4t/pages/questions/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4t/pages/questions/UrgePageVariant2'),
  },
  potty_22v4t: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4t/pages/questions/PottyQuestion').then(
        (m) => ({
          default: m.PottyQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4t/pages/questions/PottyQuestion'),
  },
  behavior_22v4t: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4t/pages/questions/BehaviorQuestion').then(
        (m) => ({
          default: m.BehaviorQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4t/pages/questions/BehaviorQuestion'),
  },
  training_22v4t: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4t/pages/questions/TrainingQuestion').then(
        (m) => ({
          default: m.TrainingQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4t/pages/questions/TrainingQuestion'),
  },
  prepare_flow_22v4t: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4t/pages/questions/prepare-flow/PrepareFlow'
      ).then((m) => ({
        default: m.PrepareFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4t/pages/questions/prepare-flow/PrepareFlow'
      ),
  },
  dog_statistics_22v4t: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4t/pages/questions/dog-statistics/DogStatistics'
      ).then((m) => ({
        default: m.DogStatistics,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4t/pages/questions/dog-statistics/DogStatistics'
      ),
  },
  email_22v4t: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4t/pages/email/Email22V4').then((m) => ({
        default: m.Email22V4,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz22_v4t/pages/email/Email22V4'),
  },
  newsletter_urge_22v4t: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4t/pages/email/components/NewsletterUrge'
      ).then((m) => ({
        default: m.NewsletterUrge,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4t/pages/email/components/NewsletterUrge'),
  },
  last_chance_offer_22v4t: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4t/pages/last-chance-offer/LastChanceOfferPage'
      ).then((m) => ({
        default: m.LastChanceOfferPage,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v4t/pages/last-chance-offer/LastChanceOfferPage'
      ),
  },
  subscriptions_22v4t: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v4t/pages/subscriptions/SubscriptionsPage'
      ).then((m) => ({
        default: m.SubscriptionsPage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4t/pages/subscriptions/SubscriptionsPage'),
  },
  cancel_offer_22v4t: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4t/pages/subscriptions/CancelOffer').then(
        (m) => ({
          default: m.CancelOffer,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4t/pages/subscriptions/CancelOffer'),
  },
  chat_upsell_22v4t: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4t/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4t/pages/upsell/ChatUpsellNewFlow'),
  },
  upsell_22v4t: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4t/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz22_v4t/pages/upsell/Upsell'),
  },
  account_nove8: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  download_22v4t: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v4t/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v4t/pages/download-app/DownloadApp'),
  },
}
